export default {
  siteTitle: 'HRSA FOIA Portal',
  supportEmail: 'FOIA@hrsa.gov'
};
